import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { frames } from '../../../Styles';
import { PageHeader } from '../../../Components';
import { Pages } from '../../../Navigation/root';
import { useAppSelector } from '../../../Store';
import { Graph_QL } from '../../../Services';

export default function Dashboard() {
  const farm = useAppSelector(({activeData}) => activeData.farm)
  const domain = useMemo(()=> (Graph_QL.ObjToString({domain: farm ?? ""})),[farm]);
  const connection = useMemo(() => (Graph_QL.create({ domain: farm ?? "" })), [farm]);
  
  const { t } = useTranslation();


  return (
    <frames.Page_inner>
        <PageHeader topHeader={t(`menuHeaders.${Pages.dashboard}`, {defaultValue: "dashboard"})} subHeader={t("menuHeaders.overview", {defaultValue: "overview"})} />

      <frames._page_inner_content_scroll>


      </frames._page_inner_content_scroll>
    </frames.Page_inner>
  );
}
